import { render, staticRenderFns } from "./GerenciadorSaldoParceiro.vue?vue&type=template&id=2e06c524"
import script from "./GerenciadorSaldoParceiro.vue?vue&type=script&lang=js"
export * from "./GerenciadorSaldoParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports